import React, { Component } from 'react';
import Button from "../elements/Buttons";

class PopupModal extends Component{
    constructor(props){
        super(props);
    }
    
    render(){
        return(
            <div className="user-data-modal hasIcon" id="errormodel">
                <div className="pre-chat">
                    <div className="user-data-modal-operators">
                        <div className="user-data-modal-operator modal-hasIcon"></div>
                    </div>
                    <form>
                        <div className="user-data-modal-text"><span>It seems you are idle for long time <br/> or <br/> started conversation in new tab.<br/>Please refresh if you want to continue.</span></div>
                        <Button
                            id="error_refresh"
                            classes="user-data-modal-submit"
                            title="Refresh"
                            hoverTitle="Refresh"
                            action={this.props.action}
                        />
                        {/* <button className="close_error_popup" id="error_close" type="button" aria-label="Close modal">Close</button> */}
                    </form>
                </div>
                <div className="user-data-modal-filler"></div>
            </div>
        )        
    }
}
PopupModal.propTypes = {
    action: React.propTypes.node,
}
export default PopupModal;